export const skeletonOverrides = { Root: { props: { boxShadow: `0px 4px 16px 0px rgba(0, 0, 0, 0.07), 0px 7px 27px 0px rgba(44, 41, 37, 0.06)`, borderRadius: '8px' } } };
